import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "react-axios";
import GenreFavoritesContainer from "~/Containers/GenreFavoritesContainer";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import { getGenreTracks } from "~/api/getGenre";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";
import styled from "styled-components";

export const WrapperNoFav = styled.section`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 12px;
`;

const Card = styled(Link)`
  display: block;
  overflow: hidden;
  color: #2c2c4a;
  text-decoration: none;
  background: #fff;
  border: 1px solid #e4e0f2;
  border-radius: 10px;

  &:hover {
    color: #2c2c4a;
    text-decoration: none;
    border-color: #66c;
  }

  img {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
  }
`;

const Initial = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  background: #f7f6fc;
  color: #66c;
  font-size: 40px;
  font-weight: 600;
`;

const Name = styled.span`
  display: block;
  padding: 10px 12px 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
`;

const ListItem = styled.section`
  line-height: 18px;
  margin: 0 10px 5px 0;
`;

const FavoriteGenreCard = ({ genre }) => {
  const [cover, setCover] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getGenreTracks(axios, genre.id, 1)
      .then(({ data }) => {
        const tracks = (data && data.tracks) || [];
        const track = tracks.find((item) => item.img_url || item.media_id) || tracks[0];
        if (!cancelled && track) setCover(track);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [genre.id]);

  return (
    <Card to={`/genre/${genre.id}`}>
      {cover ? (
        <TrackImage link={false} width="100%" alt={genre.name} track={cover} />
      ) : (
        <Initial>{(genre.name || "?").slice(0, 1)}</Initial>
      )}
      <Name>{genre.name}</Name>
    </Card>
  );
};

const ProfileFavoriteGenres = ({ dir, isOwner, variant = "list" }) => (
  <GenreFavoritesContainer
    dir={dir}
    render={({ genres }) => {
      if (genres.length === 0 && !isOwner) return null;
      return (
        <div className="profile-right-nav profile-most-recent-purchase">
          <h3>Favorite Genres</h3>
          {genres.length === 0 && isOwner ? (
            <WrapperNoFav>
              You haven't added any favorites yet.
              <br />
              <br />
              Tip: Click the {` `}
              <FontAwesomeIcon icon={faStarOutline} /> {` `}
              on any genre page to add as a favorite. For example: "<Link to={`/genre/610`}>Baked Electronics</Link>"
            </WrapperNoFav>
          ) : variant === "cards" ? (
            <Grid>
              {genres.map((genre) => (
                <FavoriteGenreCard key={genre.id} genre={genre} />
              ))}
            </Grid>
          ) : (
            <div>
              {genres.map((genre) => (
                <ListItem key={genre.id}>
                  <Link to={`/genre/${genre.id}`}>{genre.name}</Link>
                </ListItem>
              ))}
            </div>
          )}
        </div>
      );
    }}
  />
);

export default ProfileFavoriteGenres;
